// @flow

//
// React
//
import React, { useLayoutEffect, useMemo, type Node, type ComponentType } from 'react';

//
// Components
//
import HalFormsTable from './HalFormsTable';
import HalFormsViewOnlyForm from './HalFormsViewOnlyForm';
import HalFormsEditableForm from './HalFormsEditableForm';
import HalFormsTimeline from './HalFormsTimeline';
import HalFormsEmbedded from './HalFormsEmbedded';
import HalFormsContainer from './HalFormsContainer';

import HalFormsReportingTable from './halformsreporting/HalFormsReportingTable';

import HalFormsContainerRowPlain from './halformscontainer/HalFormsContainerRowPlain';
import HalFormsContainerRowPaper from './halformscontainer/HalFormsContainerRowPaper';


const HalFormsComponent = (props: {
    __componentsRegistry: any,
    __ducks: {
        actions: any,
        selectors: any,
    },
    __dataSourcesRef: any,
    __halFormsTemplate: any,

    //
    // Handlers
    //
    onChange: (value: any, meta: any) => void,
    onClose: () => void,

    // component
    c: any,

    container: any,
    data: any,
}): any => {
    const componentConfigurationId = `configuration:${props.c.id}`;
    let getConfiguration = props.__componentsRegistry.getComponent(componentConfigurationId);
    const configuration = (!getConfiguration) ? {
        visible: true,
    } : getConfiguration({
        ...props,
        data: props.data,
    });

    if (!configuration.visible) {
        return null;
    }

    if (props.c.type === 'container') {
        return (
            <HalFormsContainer
                HalFormsContainerRow={HalFormsContainerRowPlain}

                __halFormsTemplate={props.c}
                __ducks={props.__ducks}
                __dataSourcesRef={props.__dataSourcesRef}
                                                
                container={props.container}
                data={props.data}

                meta={null}

                onChange={props.onChange}
                onClose={props.onClose}
            />
        );
    }

    if (props.c.type === 'form') {
        if (props.c.editable) {
            const customComponentId = `editableForm:${props.c.identifier}`;
            let CustomComponent = props.__componentsRegistry.getComponent(customComponentId);
            if (CustomComponent) {
                return(
                    <CustomComponent
                        __componentsRegistry={props.__componentsRegistry}

                        __halFormsTemplate={props.c}
                        // __halFormsActions={props.c.actions}
                        __ducks={props.__ducks}
                        __dataSourcesRef={props.__dataSourcesRef}
                        __halFormsDataContainerId={props.__halFormsTemplate.id}

                        container={props.container}
                        data={props.data}

                        meta={null}

                        onChange={props.onChange}
                        onClose={props.onClose}
                    />
                );
            } else {
                return (
                    <HalFormsEditableForm
                        __componentsRegistry={props.__componentsRegistry}

                        __halFormsTemplate={props.c}
                        // __halFormsActions={props.c.actions}
                        __ducks={props.__ducks}
                        __dataSourcesRef={props.__dataSourcesRef}
                        __halFormsDataContainerId={props.__halFormsTemplate.id}

                        container={props.container}
                        data={props.data}

                        meta={null}

                        onChange={props.onChange}
                        onClose={props.onClose}
                    />
                );
            }
        } else {
            const customComponentId = `viewOnlyForm:${props.c.identifier}`;
            let CustomComponent = props.__componentsRegistry.getComponent(customComponentId);
            if (CustomComponent) {
                return(
                    <CustomComponent
                        __halFormsTemplate={props.c}
                        // __halFormsActions={props.c.actions}
                        __ducks={props.__ducks}
                        // __dataSourcesRef={props.__dataSourcesRef}
                        
                        container={props.container}
                        data={props.data}

                        onClose={props.onClose}
                    />
                );
            } else {
                return (
                    <HalFormsViewOnlyForm
                        __halFormsTemplate={props.c}
                        // __halFormsActions={props.c.actions}
                        __ducks={props.__ducks}
                        // __dataSourcesRef={props.__dataSourcesRef}
                        
                        container={props.container}
                        data={props.data}

                        onClose={props.onClose}
                    />
                );
            }
        }
    }

    if (props.c.type === 'table') {
        return (
            <HalFormsTable
                __halFormsTemplate={props.c}
                __halFormsActions={props.c.actions}
                __ducks={props.__ducks}
                __dataSourcesRef={props.__dataSourcesRef}
                
                container={props.container}
                data={props.data}

                onClose={props.onClose}
            />
        );
    }

    if (props.c.type === 'timeline') {
        return (
            <HalFormsTimeline
                __halFormsTemplate={props.c}
                __halFormsActions={props.c.actions}
                __ducks={props.__ducks}
                __dataSourcesRef={props.__dataSourcesRef}

                container={props.container}
                data={props.data}

                onClose={props.onClose}
            />
        );
    }

    if (props.c.type === 'embeddedContainer') {
        return (
            <HalFormsEmbedded
                __halFormsTemplate={props.c}
                __halFormsActions={props.c.actions}
                __ducks={props.__ducks}
                __dataSourcesRef={props.__dataSourcesRef}
                
                container={props.container}
                data={props.data}

                onChange={props.onChange}
                // onClose={props.onClose}
            />
        );
    }

    //
    // Reporting
    //
    if (props.c.type === 'reportingTable') {
        return(
            <HalFormsReportingTable
                __halFormsTemplate={props.c}
                __halFormsActions={props.c.actions}
                __ducks={props.__ducks}
                __dataSourcesRef={props.__dataSourcesRef}
                
                container={props.container}
                data={props.data}

                onClose={props.onClose}
            />
        );
    }

    const customPaneTypeId = `customPane:${props.c.name}`;
    let CustomPane = props.__componentsRegistry.getComponent(customPaneTypeId);
    // console.log('Trying to resolve CustomPane by id:[' + customPaneTypeId + ']');
    if (CustomPane) {
        return (
            <CustomPane
                __halFormsTemplate={props.c}
                __halFormsActions={props.c.actions}
                __ducks={props.__ducks}
                __dataSourcesRef={props.__dataSourcesRef}
                
                container={props.container}
                data={props.data}

                onChange={props.onChange}
                onClose={props.onClose}
            />
        );
    }

    return (null);
}

export default HalFormsComponent;